import { userPreferenceAPI } from '@atlassian/jira-user-preferences-services/src/utils/index.tsx';
import {
	GIC_MINI_MODAL_DISCOVERABILITY_PREFERENCE_KEY,
	GIC_PERSISTENT_STATE_PREFERENCE_KEY,
} from '../../../common/constants.tsx';
import type { PersistentIssueCreateModalView } from '../../types.tsx';
import { resolved } from './utils.tsx';

const getData = async () => {
	const [view, isDiscoPushComplete] = await Promise.all([
		resolved<PersistentIssueCreateModalView>(
			() =>
				userPreferenceAPI.get<PersistentIssueCreateModalView>(GIC_PERSISTENT_STATE_PREFERENCE_KEY),
			'modal',
		),
		resolved<boolean>(
			() => userPreferenceAPI.get(GIC_MINI_MODAL_DISCOVERABILITY_PREFERENCE_KEY),
			false,
		),
	]);
	return {
		view,
		isDiscoPushComplete,
	};
};

export default getData;
